import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { UtilityEnums } from "../../shared/utilities/enums/utillityEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { CarouselGallery, ICarouselGallery } from "./carouselGallery";
import { IPagingSelectableCarousel, PagingSelectableCarousel } from "../selectableCarousel/pagingSelectableCarousel";
import { ISinglePagingSelectableCarousel, SinglePagingSelectableCarousel } from "../selectableCarousel/singlePagingSelectableCarousel";

export interface IPagingCarouselGallery extends ICarouselGallery {

}

export class PagingCarouselGallery extends CarouselGallery implements IPagingCarouselGallery {

    public pagingSelectableCarousel: IPagingSelectableCarousel;
    public singlePagingSelectableCarousel: ISinglePagingSelectableCarousel;

    protected mainAreaPrevElement: HTMLElement; 
    protected mainAreaNextElement: HTMLElement;

    constructor(public htmlElement: Element, public carouselOrientation: UtilityEnums.ComponentOrientation, public singleCarouselOrientation: UtilityEnums.ComponentOrientation, topLevelHtmlElement?: HTMLElement) {
        super(htmlElement, carouselOrientation, singleCarouselOrientation, topLevelHtmlElement);
        this.mainAreaPrevElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PagingCarouselGallery.MainDisplayPrevElement));
        this.mainAreaNextElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PagingCarouselGallery.MainDisplayNextElement));
        let pagingSelectableCaroselElement = htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PagingSelectableCarousel.PagingSelectableCarousel));
        this.pagingSelectableCarousel = new PagingSelectableCarousel(pagingSelectableCaroselElement, carouselOrientation, this.topLevelHtmlElement);

        let singlePagingSelectableCarouselElement = htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.SinglePagingSelectableCarousel.SinglePagingSelectableCarousel));
        this.singlePagingSelectableCarousel = new SinglePagingSelectableCarousel(singlePagingSelectableCarouselElement, singleCarouselOrientation, this.topLevelHtmlElement);
    }

    dispose() {
        super.dispose();
    }
}